import type { Countries, SingleBill } from '@ctct/domain-layer';
import { myAccountApi } from '@ctct/infrastructure-layer';

import type { SingleBillInfoFormValues } from '../types';

export class FormDefaultValuesService {
  private readonly DEFAULT_COUNTRY_CODE = 'US';

  private readonly DEFAULT_CURRENCY_CODE = 'USD';

  private defaultValues: SingleBillInfoFormValues;

  constructor(private countries: Countries, private singleBill: SingleBill) {
    this.defaultValues = this.createDefaultValues();
  }

  public api() {
    return {
      getDefaultValues: () => this.getDefaultValues(),
    };
  }

  public data() {
    return {
      getDefaultValues: () => this.getDefaultValues(),
    };
  }

  public handlers() {
    return {};
  }

  public getDefaultValues = () => this.defaultValues;

  private createDefaultValues(): SingleBillInfoFormValues {
    const accountCountry = this.singleBill.getCountry();
    const firstCountryFromList = this.countries.getCountries()[0]?.code;
    const country = accountCountry || firstCountryFromList || this.DEFAULT_COUNTRY_CODE;

    const state = this.singleBill.getState();

    const email = this.singleBill.getEmail();

    const { lastname, phone, companyname } = myAccountApi.parseHiddenFields({
      lastname: this.singleBill.getLastName(),
      phone: this.singleBill.getPhone(),
      companyname: this.singleBill.getCompanyName(),
    });

    return {
      firstname: this.singleBill.getFirstName(),
      lastname,
      companyname,
      address1: this.singleBill.getAddress1(),
      address2: this.singleBill.getAddress2(),
      city: this.singleBill.getCity(),
      zipcode: this.singleBill.getZipCode(),
      phone,
      state,
      country,
      email,
      partnerContactName: this.singleBill.getPartnerContactName(),
      partnerContactEmail: this.singleBill.getPartnerContactEmail(),
      currency: this.singleBill.getCurrencyCd() || this.DEFAULT_CURRENCY_CODE,
      billingDayOfMonth: this.singleBill.getBillingDayOfMonth()
        ? String(this.singleBill.getBillingDayOfMonth())
        : String(new Date().getDate()),
      vatNumber: this.singleBill.getVatNumber() || '',
      currentTaxAgreement: Boolean(this.singleBill.getVatNumber()) || false,
    };
  }
}
